import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const mcHistory = {
  title: { de: 'Mikrocontroller-Verlauf', en: 'Microcontroller History' },
  desc: {
    de: 'Unveränderliches Einbau-/Umzugs-/Ausbau-Protokoll — Zeile öffnen für den vollständigen Eintrag',
    en: 'Append-only install / move / removal log — open a row for the full record',
  },

  statTotal: { de: 'Einträge gesamt', en: 'Total records' },
  active: { de: 'Aktiv', en: 'Active' },
  removed: { de: 'Ausgebaut', en: 'Removed' },

  colDevice: { de: 'Gerät', en: 'Device' },
  colFirmware: { de: 'Firmware', en: 'Firmware' },
  colInstalled: { de: 'Eingebaut', en: 'Installed' },
  colReason: { de: 'Grund', en: 'Reason' },
  colNotes: { de: 'Notizen', en: 'Notes' },
  colLocation: { de: 'Standort', en: 'Location' },
  roleParent: { de: 'Parent', en: 'Parent' },
  roleChild: { de: 'Child', en: 'Child' },
  openRecord: { de: 'Eintrag {name} öffnen', en: 'Open record for {name}' },

  recordId: { de: 'Eintrags-ID', en: 'Record ID' },
  deviceId: { de: 'Geräte-ID', en: 'Device ID' },
  fwAtInstall: { de: 'Firmware bei Einbau', en: 'Firmware at install' },
  duration: { de: 'Dauer', en: 'Duration' },
  removalReason: { de: 'Ausbaugrund', en: 'Removal reason' },

  day_one: { de: '{n} Tag', en: '{n} day' },
  days_many: { de: '{n} Tage', en: '{n} days' },
  // Compact duration: "21 d 4 h" / "3 h" / "< 1 h".
  durDaysHours: { de: '{d} T {h} Std.', en: '{d} d {h} h' },
  durHours: { de: '{h} Std.', en: '{h} h' },
  durUnderHour: { de: '< 1 Std.', en: '< 1 h' },
  sinceInstall: { de: 'seit Einbau', en: 'since install' },
  noNotes: { de: 'Keine Notizen.', en: 'No notes.' },
  loadMore: { de: 'Weitere laden', en: 'Load more' },
  loadedCount: { de: '{count} Einträge geladen', en: '{count} records loaded' },

  loadError: { de: 'Verlauf konnte nicht geladen werden', en: "Couldn't load history" },
  emptyTitle: { de: 'Noch kein Verlauf', en: 'No history yet' },
  emptyMsg: {
    de: 'Zuweisungs- und Lebenszyklus-Ereignisse erscheinen hier, sobald Geräte eingebaut, umgezogen und ausgemustert werden.',
    en: 'Assignment and lifecycle events appear here as devices are installed, moved, and retired.',
  },
} as const satisfies Namespace;
